import type { AccountAddressFormData } from "@/api/account-addresses"

interface AddressPreviewProps {
  address: AccountAddressFormData
}

export function AddressPreview({ address }: AddressPreviewProps) {
  const fullName = [address.firstName, address.lastName]
    .filter(Boolean)
    .join(" ")
  const streetLine = [address.street, address.number, address.complement]
    .filter(Boolean)
    .join(", ")
  const cityLine = [address.city, address.state, address.zipCode]
    .filter(Boolean)
    .join(", ")

  return (
    <div className='space-y-1 text-base leading-7'>
      {fullName && <p>{fullName}</p>}
      {streetLine && <p>{streetLine}</p>}
      {address.district && <p>{address.district}</p>}
      {cityLine && <p>{cityLine}</p>}
      {address.phone && <p>{address.phone}</p>}
      {address.email && <p>{address.email}</p>}
    </div>
  )
}
